export default {
      id: "OK-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#OK-usage",
      toString: function () {
        return this.url;
      }
    }